export const quote = {
  // Page title and description
  pageTitle: 'Demande de',
  pageTitleHighlight: 'Devis Gratuit',
  pageDescription: 'Décrivez votre projet en quelques étapes et obtenez une estimation personnalisée',
  
  // Progress
  step: 'Étape',
  of: 'sur',
  completed: 'complété',
  securityNote: 'Vos informations sont sécurisées et confidentielles',
  
  // Step 1: Work Type
  step1Title: 'Quel type de travaux souhaitez-vous réaliser ?',
  step1Description: 'Sélectionnez un ou plusieurs types de travaux',
  workTypes: {
    interiorRenovation: 'Rénovation intérieure',
    bathroom: 'Salle de bain',
    kitchen: 'Cuisine',
    basement: 'Cave',
    atticConversion: 'Aménagement de combles',
    extension: 'Extension',
    facade: 'Façade',
    roofing: 'Toiture',
    flooring: 'Sol',
    painting: 'Peinture',
    electricity: 'Électricité',
    plumbing: 'Plomberie',
    carpentry: 'Menuiserie',
    insulation: 'Isolation',
    other: 'Autre'
  },
  selectAtLeastOne: 'Veuillez sélectionner au moins un type de travaux',
  
  // Step 2: Housing Type
  step2Title: 'Quel est le type de logement ?',
  step2Description: 'Choisissez le type de votre bien',
  housingTypes: {
    apartment: 'Appartement',
    house: 'Maison',
    studio: 'Studio',
    duplex: 'Duplex',
    loft: 'Loft',
    commercial: 'Local commercial',
    office: 'Bureau'
  },
  selectHousingType: 'Veuillez sélectionner un type de logement',
  
  // Step 3: Location
  step3Title: 'Où se situe le projet ?',
  step3Description: 'Entrez le code postal et la ville',
  postalCode: 'Code postal',
  postalCodePlaceholder: 'Ex: 1000',
  city: 'Ville',
  cityPlaceholder: 'Ex: Bruxelles',
  selectCity: 'Sélectionnez une ville',
  invalidPostalCode: 'Code postal invalide',
  fillBothFields: 'Veuillez remplir les deux champs',
  
  // Step 4: Project Details
  step4Title: 'Détails du projet',
  step4Description: 'Parlez-nous de votre projet',
  projectDescription: 'Description du projet',
  descriptionPlaceholder: 'Décrivez votre projet en détail : travaux souhaités, surface, préférences...',
  estimatedBudget: 'Budget estimé',
  budgetPlaceholder: 'Ex: 10 000 - 15 000 €',
  desiredDeadline: 'Délai souhaité',
  deadlinePlaceholder: 'Ex: Dans 3 mois',
  photos: 'Photos (optionnel)',
  photosNote: 'Si vous avez des photos, vous pourrez les envoyer ultérieurement par email',
  photosPlaceholder: 'Nous vous demanderons les photos plus tard si nécessaire',
  fillDescription: 'Veuillez remplir la description du projet',
  
  // Step 5: Contact
  step5Title: 'Vos coordonnées',
  step5Description: 'Dernière étape ! Comment pouvons-nous vous contacter ?',
  fullName: 'Nom complet',
  namePlaceholder: 'Ex: Jean Dupont',
  phone: 'Téléphone',
  phonePlaceholder: 'Ex: +32 123 45 67 89',
  email: 'Email',
  emailPlaceholder: 'Ex: jean.dupont@email.com',
  dataProtection: 'Vos données sont protégées',
  dataProtectionText: 'Nous utilisons vos informations uniquement pour vous contacter au sujet de votre demande de devis.',
  required: '*',
  
  // Buttons
  next: 'Suivant',
  previous: 'Précédent',
  back: 'Retour',
  submit: 'Obtenir mon devis',
  submitting: 'Envoi en cours...',
  
  // Success
  successTitle: 'Merci !',
  successSubtitle: 'Votre demande a été reçue avec succès',
  successMessage: 'Nous vous contactons dans les plus brefs délais pour discuter de votre projet et vous fournir un devis détaillé.',
  successNextSteps: 'Prochaines étapes :',
  successStep1: 'Nous examinerons attentivement votre demande',
  successStep2: 'Nous vous contacterons sous 24-48 heures',
  successStep3: 'Nous fixerons un rendez-vous pour une visite sur place si nécessaire',
  successStep4: 'Vous recevrez un devis détaillé et personnalisé',
  backToHome: 'Retour à l\'accueil',
  
  // Error messages
  errorSubmitting: 'Une erreur est survenue. Veuillez réessayer.',
};